import moment from 'moment';
import queryString from 'qs';

const getExportSelloutRequest = (payload) => {
    const [startDate, endDate] = payload?.sellout_date ?? [];
    const formatArray = (arr) => (arr && arr.length > 0 ? arr.join(',') : undefined);

    const data = {
        group: payload.group.name || undefined,
        customer_id: payload.customer.id || undefined,
        start_date: startDate
            ? moment(startDate?.format()).format('YYYY-MM-DD')
            : moment().startOf('month').format('YYYY-MM-DD'),
        end_date: endDate ? moment(endDate?.format()).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        brand: formatArray(payload.brand),
        product: formatArray(payload.product),
        agg: formatArray(payload.agg),
        dc: formatArray(payload.dc),
        type: payload.type,
    };

    return queryString.stringify(data, { skipNulls: true });
};

export default getExportSelloutRequest;
